import Vue from 'vue'

import {
    Tabs,
    Icon,
    Stepper,
    Swipe,
    SwipeItem,
    Popup,
    Tab,
    Button,
    Form,
    Field,
    Picker,
    Toast,
    Dialog,
    List,
    Loading,
    AddressList,
    Cell,
    Switch,
    Empty
} from 'vant'
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(Stepper)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(AddressList)
Vue.use(List)
Vue.use(Cell)
Vue.use(Switch)
Vue.use(Empty)
Vue.prototype.$message = Toast
Vue.prototype.$confirm = Dialog.confirm
Vue.prototype.$alert = Dialog.alert
Vue.prototype.$errorHandler = error => {
    let msg
    if (error instanceof Error) {
        msg = error.message
    } else {
        msg = error
    }
    Toast.fail(msg)
}
Toast.allowMultiple()
// Toast.setDefaultOptions({ duration: 100000 });